/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.update.service.ts.
 */
import {ApplicationRef, Injectable} from '@angular/core';
import {SwUpdate, VersionEvent} from '@angular/service-worker';
import {AppDialogsService} from './app.dialogs.service';
import {BehaviorSubject, concat, interval} from 'rxjs';
import {first} from 'rxjs/operators';
import {AppConfigService} from './app.config.service';
import {AppAsyncTimeout} from '../helpers/app.asyncTimeout';

/**
 * Zweck: Beschreibt class AppUpdateService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppUpdateService {

  updateAvailable = new BehaviorSubject<boolean>(false);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(appRef: ApplicationRef, public updates: SwUpdate, private dsvc: AppDialogsService, private cfg: AppConfigService) {
    updates.versionUpdates.subscribe((event: VersionEvent) => {
      if (event.type == 'VERSION_READY') {
        this.triggerUpdateIsAvailable();
      }
    });

    updates.unrecoverable.subscribe(event => {
      this.dsvc.info(
        'error',
        'Update Fehlgeschlagen!',
        'Applikation startet neu!');
      AppAsyncTimeout.setTimeout(() => {
        document.location.reload();
      }, 1500);
    });

    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    const everyEvery5Seconds$ = interval(5 * 1000);
    const checkOnceAppIsStable$ = concat(appIsStable$, everyEvery5Seconds$);

    checkOnceAppIsStable$.subscribe(() => this.checkForUpdates());
  }

/**
 * Beschreibt Methode checkForUpdates und ihren Rückgabevertrag.
 */
  checkForUpdates() {
    if (!this.cfg.isDebug() && this.updates.isEnabled) {
      this.updates.checkForUpdate();
    }
  }

/**
 * Beschreibt Methode triggerUpdateIsAvailable und ihren Rückgabevertrag.
 */
  triggerUpdateIsAvailable() {
    this.updateAvailable.next(true);
  }

/**
 * Beschreibt Methode installUpdate und ihren Rückgabevertrag.
 */
  installUpdate() {
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}
